module.exports = fox._r("components/common/images/discount-sticker.png", __webpack_public_path__ + "_/_/_/root/components/common/images/discount-sticker.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/images/discount-sticker.png
// module id = 56
// module chunks = 4